import React, { useState } from "react"
import { useSelector } from "react-redux"

import { ACTIVE, YES } from "const"
import {
    PRM_HELP,
    StoreType,
    PackageSettings,
    moduleIds,
} from "client/store"
import {
    PageContent,
    Collapse,
    PermissionTable,
} from "client/components"

import Columns from "./columns"

interface AccountPermissionsProps {
    accountId: number
    packageSettings: PackageSettings
}

const AccountPermissions = ({
    accountId,
    packageSettings,
}: AccountPermissionsProps) => {
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const permissions = useSelector((state: StoreType) => state.accountPermissions.accountPermissions)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const [showAccount, setShowAccount] = useState(true)
    const [showCc, setShowCc] = useState(false)
    const [showLifecycle, setShowLifecycle] = useState(false)
    const [showQid, setShowQid] = useState(false)
    const [showSil, setShowSil] = useState(false)
    const [showOkr, setShowOkr] = useState(false)
    const [showRrs, setShowRrs] = useState(false)
    const [showMarkov, setShowMarkov] = useState(false)

    const {
        ccModuleAccess,
        lifecycleModuleAccess,
        qidModuleAccess,
        silModuleAccess,
        okrModuleAccess,
        rrsRiskSpaceModuleAccess,
        markovModuleAccess,
    } = packageSettings

    const {
        cc,
        lifecycle,
        qid,
        sil,
        riskSpace,
        markov,
    } = moduleIds

    const columns = Columns(accountId)

    return (
        <PageContent>
            <Collapse
                show={showAccount}
                title={lang.account}
                onCollapse={() => setShowAccount(!showAccount)}
            >
                <PermissionTable
                    columns={columns}
                    section="account"
                    dataList={permissions.account}
                    hiddenPermissions={userData.accountId !== 1 ? [PRM_HELP] : []} // only Super Admin can see PRM_HELP
                />
            </Collapse>
            {
                (accountId === 1 || (ccModuleAccess === YES && moduleList[cc].status === ACTIVE))
                && (
                    <Collapse
                        show={showCc}
                        title={moduleList[cc].name}
                        onCollapse={() => setShowCc(!showCc)}
                    >
                        <PermissionTable
                            columns={columns}
                            section="complianceCase"
                            dataList={permissions.complianceCase}
                        />
                    </Collapse>
                )
            }
            {
                (accountId === 1 || (lifecycleModuleAccess === YES && moduleList[lifecycle].status === ACTIVE))
                && (
                    <Collapse
                        show={showLifecycle}
                        title={moduleList[lifecycle].name}
                        onCollapse={() => setShowLifecycle(!showLifecycle)}
                    >
                        <PermissionTable
                            columns={columns}
                            section="lifecycle"
                            dataList={permissions.lifecycle}
                        />
                    </Collapse>
                )
            }
            {
                (accountId === 1 || (qidModuleAccess === YES && moduleList[qid].status === ACTIVE))
                && (
                    <Collapse
                        show={showQid}
                        title={moduleList[qid].name}
                        onCollapse={() => setShowQid(!showQid)}
                    >
                        <PermissionTable
                            columns={columns}
                            section="qid"
                            dataList={permissions.qid}
                        />
                    </Collapse>
                )
            }
            {
                (accountId === 1 || (silModuleAccess === YES && moduleList[sil].status === ACTIVE))
                && (
                    <Collapse
                        show={showSil}
                        title={moduleList[sil].name}
                        onCollapse={() => setShowSil(!showSil)}
                    >
                        <PermissionTable
                            columns={columns}
                            section="sil"
                            dataList={permissions.sil}
                        />
                    </Collapse>
                )
            }
            {
                (accountId === 1 || okrModuleAccess === YES)
                && (
                    <Collapse
                        show={showOkr}
                        title={lang.objectivesKeyResults}
                        onCollapse={() => setShowOkr(!showOkr)}
                    >
                        <PermissionTable
                            columns={columns}
                            section="okr"
                            dataList={permissions.okr}
                        />
                    </Collapse>
                )
            }
            {
                (accountId === 1 || rrsRiskSpaceModuleAccess === YES)
                && (
                    <Collapse
                        show={showRrs}
                        title={moduleList[riskSpace].name}
                        onCollapse={() => setShowRrs(!showRrs)}
                    >
                        <PermissionTable
                            columns={columns}
                            section="rrs"
                            dataList={permissions.rrs}
                        />
                    </Collapse>
                )
            }
            {
                (accountId === 1 || markovModuleAccess === YES)
                && (
                    <Collapse
                        show={showMarkov}
                        title={moduleList[markov].name}
                        onCollapse={() => setShowMarkov(!showMarkov)}
                    >
                        <PermissionTable
                            columns={columns}
                            section="markov"
                            dataList={permissions.markov}
                        />
                    </Collapse>
                )
            }
        </PageContent>
    )
}
export default AccountPermissions
